import ViewUtil from '../ViewUtil';
import showLoginDialog from './showLoginDialog';
import showLoginPopup from './showLoginPopup';
import t from './../i18n/I18n';

/**
 * Method decorator. For authenticated users, this is a no-op.
 * For link users, this prompts the user to login before
 * executing the wrapped method.
 */
export default function loginRequired(target, name, descriptor) {
  const original = descriptor.value;
  descriptor.value = function (...args) {
    if (!ViewUtil.isDirectLinkToCollection()) {
      return original.apply(this, args);
    }

    //return null;
    return showLoginDialog(name)
      .then((success) => {
        if (success) {
          return original.apply(this, args);
        }
        else {
          throw new Error(t("ACTION_REQUIRES_LOGIN", { action: name }));
        }
      })
      .catch(err => {
        console.error(err);
        throw new Error(t("ACTION_REQUIRES_LOGIN", { action: name }), { cause: err });
      });
  };

  return descriptor;
}
